var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.34 36.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".applePay1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.32,4.78A6.54,6.54,0,0,0,17.83.11a6.49,6.49,0,0,0-4.31,2.23A6.14,6.14,0,0,0,12,6.83a5.39,5.39,0,0,0,4.35-2",
    transform: "translate(-0.16 -0.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.81,7.16c-2.4-.15-4.44,1.36-5.59,1.36s-2.9-1.29-4.8-1.26a7.11,7.11,0,0,0-6,3.66C-1.19,15.37.71,22,3.22,25.59c1.22,1.79,2.69,3.77,4.63,3.7s2.54-1.19,4.76-1.19,2.87,1.19,4.81,1.15,3.26-1.79,4.48-3.59a15.42,15.42,0,0,0,2-4.12A6.53,6.53,0,0,1,20,15.62a6.65,6.65,0,0,1,3.15-5.56,6.87,6.87,0,0,0-5.34-2.9",
    transform: "translate(-0.16 -0.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.76,2.16A8.44,8.44,0,0,1,50.61,11c0,5.25-3.71,8.87-9,8.87H35.85v9.19H31.67V2.16ZM35.85,16.37h4.79c3.64,0,5.7-2,5.7-5.36s-2.06-5.33-5.68-5.33H35.85Z",
    transform: "translate(-0.16 -0.11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65,23.49c0-3.45,2.63-5.43,7.48-5.73l5.2-.31V16c0-2.19-1.44-3.38-4-3.38-2.11,0-3.64,1.08-4,2.74H52.62c.11-3.49,3.39-6,7.83-6,4.77,0,7.89,2.5,7.89,6.38V29.06H64.48V25.84h-.1a6.89,6.89,0,0,1-6.15,3.43C54.35,29.27,51.65,27,51.65,23.49Zm12.68-1.74V20.24l-4.64.3c-2.61.17-4,1.14-4,2.84s1.41,2.7,3.63,2.7C62.18,26.08,64.33,24.27,64.33,21.75Z",
    transform: "translate(-0.16 -0.11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.89,36.26V33a11.21,11.21,0,0,0,1.23.08c1.84,0,2.89-.78,3.52-2.8L77,29.12,70,9.54h4.36l4.92,15.89h.09L84.25,9.54H88.5L81.17,30.11c-1.68,4.71-3.6,6.26-7.66,6.26A12.12,12.12,0,0,1,71.89,36.26Z",
    transform: "translate(-0.16 -0.11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/apple-pay.c8b66304f07599ca20dfcf1f3be6a79f.svg";
export { ForwardRef as ReactComponent };